export default function Screenshot({ src }: { src: string }) {
  return (
    <div className="rounded-2xl bg-white p-4 shadow-xl">
      <img src={src} className="rounded-lg shadow" />
    </div>
  )
}
